import { render, staticRenderFns } from "./ButtonElement.vue?vue&type=template&id=1dac04c9&scoped=true&"
import script from "./ButtonElement.vue?vue&type=script&lang=js&"
export * from "./ButtonElement.vue?vue&type=script&lang=js&"
import style0 from "./ButtonElement.vue?vue&type=style&index=0&id=1dac04c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dac04c9",
  null
  
)

export default component.exports